export type PageSurfaceMode = "white" | "tint";

export const PAGE_SURFACE_MODE: PageSurfaceMode = "tint";

const PAGE_SURFACES = {
  white: {
    appBackground: "#ffffff",
    pageBackground: "#ffffff",
    pageBackgroundGradient: "linear-gradient(180deg, #ffffff 0%, #ffffff 100%)",
    sectionBackground: "#ffffff",
    elevatedPanel: "#ffffff",
    elevatedPanelGradient:
      "linear-gradient(180deg, rgba(255,255,255,0.99) 0%, rgba(255,255,255,0.99) 100%)",
    border: "rgba(15, 23, 42, 0.08)",
  },
  tint: {
    appBackground: "#fafbfd",
    pageBackground: "#fafbfd",
    pageBackgroundGradient: "#fafbfd",
    sectionBackground: "#fafbfd",
    elevatedPanel: "#ffffff",
    elevatedPanelGradient: "#ffffff",
    border: "#e2e8f0",
  },
} as const;

export function getPageSurfaceConfig() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE];
}

export function getPageSurfaceGradient() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE].pageBackgroundGradient;
}

export function getPageSurfaceSolid() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE].pageBackground;
}

export function getElevatedPageSurfaceGradient() {
  return PAGE_SURFACES[PAGE_SURFACE_MODE].elevatedPanelGradient;
}
